import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "@arcadeai/design-system/components/ui/atoms/breadcrumb";
import type { AnyRouteMatch } from "@tanstack/react-router";
import { isMatch, Link, useMatches } from "@tanstack/react-router";
import { memo } from "react";

const selectBreadcrumbData = (matches: AnyRouteMatch[]) => {
  const matchesWithCrumbs = matches.filter((match) =>
    isMatch(match, "loaderData.crumb")
  );

  const hasPendingMatch = matches.some((match) => match.status === "pending");

  return {
    matches: matchesWithCrumbs.map((match) => ({
      id: match.id,
      fullPath: match.fullPath,
      crumb: match.loaderData?.crumb,
    })),
    hasPending: hasPendingMatch,
  };
};

export const Breadcrumbs = memo(() => {
  const breadcrumbData = useMatches({
    select: selectBreadcrumbData,
  });

  if (breadcrumbData.hasPending) {
    return null;
  }

  return (
    <Breadcrumb>
      <BreadcrumbList>
        {breadcrumbData.matches.map((match, i) => {
          const isLastItem = i + 1 === breadcrumbData.matches.length;
          // Remove trailing slash if present
          const path = match.fullPath.endsWith("/")
            ? match.fullPath.slice(0, -1)
            : match.fullPath;

          return (
            <BreadcrumbItem className="hidden md:flex" key={match.id}>
              {isLastItem ? (
                <BreadcrumbPage>{match.crumb}</BreadcrumbPage>
              ) : (
                <ul className="flex items-center gap-2">
                  <BreadcrumbLink render={<Link to={path} />}>
                    {match.crumb}
                  </BreadcrumbLink>
                  <BreadcrumbSeparator />
                </ul>
              )}
            </BreadcrumbItem>
          );
        })}
      </BreadcrumbList>
    </Breadcrumb>
  );
});
